import { IPayrollFilters } from "src/app/modules/logged/payrolls/store/types";

export class SetCurrentPaymentTab {
    static readonly type = '[payrolls] set current payments tab';
    constructor(public tab?: 'GENERAL' | 'SUBCONTRACTORS') { }
}

export class SetCurrentTimesheetTab {
    static readonly type = '[payrolls] set current timesheet tab';
    constructor(public tab?: 'WORKED' | 'DIDN\'T WORK') { }
}

export class SetCurrentTab {
    static readonly type = '[payrolls] set current tab';
    constructor(public tab?: 'GENERAL' | 'DASHBOARD', public filters?: Partial<IPayrollFilters>) { }
}

export class SetSearchField {
    static readonly type = '[payrolls] set search field';
    constructor(public value: string) { }
}

export class SetFiltersBasedOnTab {
    static readonly type = '[payrolls] set filters based on tab';
    constructor(public filters?: Partial<IPayrollFilters>) { }
}

export class SetSendNotificationsID {
    static readonly type = '[payrolls] set send notifications ID';
    constructor(public id: string) { }
}

export class SetAmendPayroll {
    static readonly type = '[payrolls] set amend payroll';
    constructor(public id: string) { }
}

export class FetchChart {
    static readonly type = '[payrolls] fetch chart';
    constructor(public companyID: string) { }
}

export class FetchOne {
    static readonly type = '[payrolls] fetch one';
    constructor(public id: string) { }
}

export class UpdateOne {
    static readonly type = '[payrolls] update one';
    constructor(public id: string, public data: any) { }
}

export class AmendTimesheet {
    static readonly type = '[payrolls] amend timesheet';
    constructor() { }
}

export class AuthPayments {
    static readonly type = '[payrolls] auth payments';
    constructor(public code: string) { }
}

export class ValidateAuthPayments {
    static readonly type = '[payrolls] validate auth payments';
    constructor() { }
}
